import { Folder } from '@nbirl/nbi-common-ui-libs';

const getNextCopyName = (copyName: string, folders: Folder[]): string => {
  const condition = new RegExp(`${copyName}(?: \\((\\d+)\\))*$`);

  const numberOfMatches = folders?.reduce((acc, curr) => {
    const matches = curr.name.match(condition);

    return matches ? Math.max(parseInt(matches[1]) || 0, acc) : acc;
  }, -1);

  return numberOfMatches >= 0
    ? `${copyName} (${numberOfMatches + 1})`
    : copyName;
};

export const getCopyFolderName = (folders: Folder[], folderName: string) => {
  const copySuffix = `_copy`;
  const copyPatternCheck = new RegExp(`(\\w*) \\(\\d+\\)$`);
  const multipleCopies = folderName.match(copyPatternCheck);

  if (multipleCopies) {
    return getNextCopyName(multipleCopies[1], folders);
  }

  return getNextCopyName(
    folderName.includes(copySuffix) ? folderName : `${folderName}${copySuffix}`,
    folders
  );
};
